export { default as StrategyProfileContent } from './StrategyProfileContent';
